export default {
    state: {
        current_tab:'index',
        current_tabs:[
            {code:'index',content:'home'},
        ],
    },
    getters: {
        
    },
    mutations: {
        currentTabShow(state,news){
            state.current_tab = news;
        },
        currentTabsList(state,news){
            state.current_tabs = news;
        }
    },
    actions: {
        
    }
}
